import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditBlogCategory from "../../components/blog-categories/FormAddEditBlogCategory";
import { useGetBlogCategory } from "../../hooks/blog-categories/useGetBlogCategory";
import LoadingPage from "../../components/global/LoadingPage";

const EditBlogCategory = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, category } = useGetBlogCategory(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/blog/categories");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditBlogCategory isEdit={true} currentData={category} onSubmitSuccess={handleSuccess} />
        </WrapperSection>
    );
};

export default EditBlogCategory;
